import { headers, dataTypes } from 'constants/tableColumns';

/**
 * Table header names
 * Ref: https://synpulse.atlassian.net/browse/US-61
 */
export const detailedViewTable = [
    {
        i: 1,
        w: '5.85%',
        th: headers.tradeDate, // Creation Date
        prop: 'tradeDate',
        type: dataTypes.string
    },
    {
        i: 2,
        w: '7.85%',
        th: headers.orderId, // Op Code
        prop: 'orderId',
        type: dataTypes.string
    },
    {
        i: 3,
        w: '6.85%',
        th: headers.portfolioId, // Portfolio Number
        prop: 'portfolioId',
        type: dataTypes.string
    },
    {
        i: 4,
        w: '4.85%',
        th: headers.cifId, // CTO Code
        prop: 'cifId',
        type: dataTypes.number
    },
    {
        i: 5,
        w: '4.85%',
        th: headers.rm, // CTO Code
        prop: 'rm',
        type: dataTypes.string
    },
    {
        i: 6,
        w: '6.85%',
        th: headers.rmGroup, // Team
        prop: 'rmGroup',
        type: dataTypes.string
    },
    {
        i: 7,
        w: '6.85%',
        th: headers.rmRegion, // Market
        prop: 'rmRegion',
        type: dataTypes.string
    },
    {
        i: 8,
        w: '4.85%',
        th: headers.orderType, // Op Nature
        prop: 'orderType',
        type: dataTypes.string
    },
    {
        i: 9,
        w: '6.85%',
        th: headers.orderInitiated, // Order Initiation
        prop: 'orderInitiated',
        type: dataTypes.string
    },
    {
        i: 10,
        w: '6.85%',
        th: headers.instrumentType, // Instrument Type
        prop: 'instrumentType',
        type: dataTypes.string
    },
    {
        i: 11,
        w: '7.85%',
        th: headers.instrumentSubType, // Instrument Subtype
        prop: 'instrumentSubType',
        type: dataTypes.string
    },
    {
        i: 12,
        w: '10.85%',
        th: headers.instrumentCode, // Instrument Code
        prop: 'instrumentCode',
        type: dataTypes.string
    },
    {
        i: 13,
        w: '10.85%',
        th: headers.instrumentName, // Instrument Name
        prop: 'instrumentName',
        type: dataTypes.string
    },
    {
        i: 14,
        w: '4.85%',
        th: headers.vcStatus, // VC Status
        prop: 'vcStatus',
        type: dataTypes.string
    }
];
